export const enum UserRoles {
    Admin = "admin",
    AccountManagerAdmin = "accountmanageradmin",
    ContentProviderUser = "contentprovideruser",
    ServiceProviderAdmin = "serviceprovideradmin"
}
